module.exports = __webpack_public_path__ + "img/user-default.06a3d6b.webp";